import type { Context, RefObject } from 'react';
import { createContext, useContext } from 'react';

interface ArticleScrollRefs {
  readonly scrollDestinationRef: RefObject<HTMLDivElement> | undefined;
}

const defaultOptions: ArticleScrollRefs = {
  scrollDestinationRef: undefined,
};

export const ArticleScrollContext: Context<ArticleScrollRefs> = createContext(defaultOptions);

export const useArticleScrollContext = (): ArticleScrollRefs => useContext(ArticleScrollContext);
